import React from 'react'
import './header.css'
import { useTranslation } from "react-i18next";
import img_card from "../../../assets/img/tarjeta-dinamica-1.png";

const Header = () => {
  const [t, i18n] = useTranslation("actividad");

  return (
    <div class="SB_header_bg-Black">
      <div class="SB_header_act">
        <div class="SB_header_titulo fade-in-fwd">
          {/*<h2>{(t('header.sobre-mi'))} <br></br><span class="SB_header_tituloNaranja">{(t('header.sobre-mi2'))}</span></h2> */}
          <h2><span class="SB_header_tituloNaranja">Salinas </span>Match</h2>
        </div>
        <div class="SB_header_parrafo fade-in-fwd">
          <p>¿Qué tan parecido es tu pensamiento con el de Ricardo Salinas?<span className='nly-desk'><br></br><br></br><span className='txt-tit-act-d'>Responde 5 preguntas y descubre cuánto coinciden tus ideas con las suyas.</span></span></p>
        </div>
        {/*<div class="SB_header_nombre fade-in-fwd qizz-ret">
          <p className='txtreto'>¡Te reto!</p>
        </div> */}
        <div class="SB_header_nombre fade-in-fwd qizz-ret">
          <a className='btn-reto-acep' href='/5bfd0e31-af85-4bb1-91c8-997d81fec963'>¡Que comience el juego!</a>
        </div>


      </div>
      <div class="SB_body_act">
        {/*<h2>¡Que comience el juego!</h2> */}

        <div className='card-juguemos'>
          <div className='juguemos-back'>

            <p><span className='nly-mov'>Responde 5 preguntas y descubre cuánto coinciden tus ideas con las suyas. <br></br><br></br></span><strong>*Tip: </strong>responde con más detalle para obtener un análisis más preciso.</p>
          </div>


        </div>
        {/*<div className='card-juguemos'>
          <div className='juguemos-front'>
            <img src={img_card}></img>
          </div>
          <div className='juguemos-back'>

            <p>Responde 5 preguntas y descubre cuánto coinciden tus ideas con las suyas. <br></br><br></br><strong>*Tip: </strong>responde con más detalle para obtener un análisis más preciso.</p>
          </div>


        </div>*/}
        <a className='btn-reto-acep' href='/5bfd0e31-af85-4bb1-91c8-997d81fec963'>¡Que comience el juego!</a>
      </div>
    </div>
  )
}

export default Header
